<script>
import { helpers, notificationTimeout } from '@/store/modules/notifications';
import * as types from '@/store/types';

export default {
  data: () => ({ timeout: notificationTimeout }),
  computed: {
    ...helpers.mapState(['show', 'message', 'icon', 'iconColor', 'color']),
    shouldShowSnackbar: {
      get() {
        return this.show;
      },
      set(show) {
        this.setFields({ show });
      },
    },
  },
  mounted() {
    if (this.show) this.reset();
  },
  methods: {
    ...helpers.mapMutations({ setFields: types.SET_FIELDS }),
    ...helpers.mapActions({ reset: types.RESET_SNACKBAR }),
  },
};
</script>

<template>
  <v-snackbar
    v-model="shouldShowSnackbar"
    bottom
    right
    multi-line
    :timeout="timeout"
    :color="color"
  >
    <v-icon v-if="icon" :color="iconColor">
      {{ icon }}
    </v-icon>
    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn
        color="primary"
        text
        v-bind="attrs"
        @click="shouldShowSnackbar = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>
